async function settleInBatches<T, R>(
  items: T[],
  batchSize: number,
  run: (item: T) => Promise<R>,
): Promise<PromiseSettledResult<R>[]> {
  if (!Number.isInteger(batchSize) || batchSize < 1) throw new RangeError('batchSize must be a positive integer');
  const results: PromiseSettledResult<R>[] = [];
  for (let start = 0; start < items.length; start += batchSize) {
    results.push(
      ...(await Promise.allSettled(
        items.slice(start, start + batchSize).map((item) => Promise.resolve().then(() => run(item))),
      )),
    );
  }
  return results;
}

export { settleInBatches };
